// src/admin/components/TagsTable.jsx

import { useTheme } from "../../context/ThemeContext";

export default function TagsTable({
    tags,
    onEdit,
    onDelete,
    deletingId,
}) {
    const { isDark } = useTheme();

    return (
        <div
            className={`
                overflow-hidden
                rounded-3xl
                border
                ${
                    isDark
                        ? "border-white/10"
                        : "border-gray-200"
                }
            `}
        >
            <table className="w-full">
                <thead
                    className={
                        isDark
                            ? "bg-white/5"
                            : "bg-gray-50"
                    }
                >
                    <tr>
                        <th className="p-4 text-left">
                            Name
                        </th>

                        <th className="p-4 text-left">
                            Slug
                        </th>

                        <th className="p-4 text-left">
                            Actions
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {tags.length === 0 ? (
                        <tr>
                            <td
                                colSpan={3}
                                className="
                                    p-8
                                    text-center
                                    opacity-60
                                "
                            >
                                No tags found.
                            </td>
                        </tr>
                    ) : (
                        tags.map((tag) => (
                            <tr
                                key={tag.id}
                                className={`
                                    border-t
                                    ${
                                        isDark
                                            ? "border-white/10"
                                            : "border-gray-200"
                                    }
                                `}
                            >
                                <td className="p-4 font-medium">
                                    {tag.name}
                                </td>

                                <td className="p-4">
                                    {tag.slug}
                                </td>

                                <td className="p-4">
                                    <div className="flex gap-3">
                                        <button
                                            onClick={() => onEdit(tag)}
                                            className="text-cyan-500"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() => onDelete(tag.id)}
                                            disabled={deletingId === tag.id}
                                            className="
                                                text-red-500
                                                disabled:opacity-50
                                            "
                                        >
                                            {deletingId === tag.id
                                                ? "Deleting..."
                                                : "Delete"}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}